import script from "./MaterialForm.vue?vue&type=script&setup=true&lang=js"
export * from "./MaterialForm.vue?vue&type=script&setup=true&lang=js"

import "./MaterialForm.vue?vue&type=style&index=0&id=71de4efa&scoped=true&lang=less"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-71de4efa"]])

export default __exports__